import { z } from "zod";

export const createGuestSchema = z.object({
  name: z.string().min(1, "Por favor ingresa el nombre del usuario"),
  email: z
    .string()
    .optional()
    .refine(
      (value) => {
        if (!value) return true;
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      },
      {
        message: "El correo no tiene un formato válido",
      }
    ),
  phone: z
    .string()
    .optional()
    .refine(
      (value) => {
        if (!value) return true;
        return /^\+\d{7,15}$/.test(value);
      },
      {
        message: "El número debe tener entre 7 y 15 dígitos",
      },
    ),
  origin_id: z.string().optional(),
});

export type CreateGuestSchema = z.infer<typeof createGuestSchema>;
